import React from "react";
import "./App.css";
import Navbar from "./Navbar";
//import Footer from "./Footer";
import ContentSection from "./ContentSection";
import {Link} from 'react-router-dom';

const About = () => {
return(
<div>
<ContentSection/>
</div>
);
};




export default About;